<sc-flex vertical stretchContent fitHeight>
  <div class="no-field-space" [formGroup]="fromGroup">
    <sc-flex>
      <sc-date-field-legacy formControlName="dateFrom"
        labelDictionaryKey="tmc-common.reports.ui.area-gate-log.date-from-field"></sc-date-field-legacy>
      <sc-content-spacer></sc-content-spacer>
      <sc-date-field-legacy formControlName="dateUntil"
        labelDictionaryKey="tmc-common.reports.ui.area-gate-log.date-until-field"></sc-date-field-legacy>
      <sc-content-spacer></sc-content-spacer>
      <sc-select-field formControlName="type" [data]="types" class="type-field"
        labelDictionaryKey="tmc-common.reports.ui.area-gate-log.type-field"></sc-select-field>
      <sc-content-spacer></sc-content-spacer>
      <sc-button dictionaryKey="common.action.refresh" (click)="refresh()"></sc-button>
    </sc-flex>
  </div>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-flex-fitting-content vertical>
    <sc-flex fitHeight stretchContent>
      <div>
        <sc-scroll-pane>

          <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortChanged($event)"
            class="transport-table">

            <ng-container matColumnDef="date">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>
                <sc-dictionary-label
                  dictionaryKey="tmc-common.reports.ui.area-gate-log.date-column"></sc-dictionary-label>
              </th>
              <td mat-cell class="text-selection" *matCellDef="let row"
                [ngClass]="{'selected' : row.id === selected?.id}">
                {{row.date | timestamp }}
              </td>
            </ng-container>

            <ng-container matColumnDef="gate">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>
                <sc-dictionary-label
                  dictionaryKey="tmc-common.reports.ui.area-gate-log.gate-column"></sc-dictionary-label>
              </th>
              <td mat-cell class="text-selection" *matCellDef="let row"
                [ngClass]="{'selected' : row.id === selected?.id}">
                {{row.gate}}
              </td>
            </ng-container>

            <ng-container matColumnDef="direction">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>
                <sc-dictionary-label
                  dictionaryKey="tmc-common.reports.ui.area-gate-log.direction-column"></sc-dictionary-label>
              </th>
              <td mat-cell class="text-selection" *matCellDef="let row"
                [ngClass]="{'selected' : row.id === selected?.id}">
                <sc-dictionary-label dictionaryKey="tmc-common.common.enum.area-gate-direction.{{row.direction }}"></sc-dictionary-label>
              </td>
            </ng-container>

            <ng-container matColumnDef="event">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>
                <sc-dictionary-label
                  dictionaryKey="tmc-common.reports.ui.area-gate-log.event-column"></sc-dictionary-label>
              </th>
              <td mat-cell class="text-selection" *matCellDef="let row"
                [ngClass]="{'selected' : row.id === selected?.id}">
                <sc-dictionary-label dictionaryKey="tmc-common.common.enum.area-gate-log-event.{{row.event}}"></sc-dictionary-label>

              </td>
            </ng-container>

            <ng-container matColumnDef="filler">
              <th mat-header-cell *matHeaderCellDef style="width: 100%;"> &nbsp; </th>
              <td mat-cell *matCellDef="let row" [ngClass]="{'selected' : row.id === selected?.id}"> &nbsp;</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

            <tr mat-row *matRowDef="let row; columns: columnsToDisplay" (click)="onClickRow(row)"></tr>

          </table>
        </sc-scroll-pane>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <sc-flex-fitting-content>
        <ac-resource-image-view [resourceId]="selected?.resourceId"></ac-resource-image-view>
      </sc-flex-fitting-content>
    </sc-flex>
  </sc-flex-fitting-content>
</sc-flex>
